<template>
  <div class="mapboxgl-custom-legend">
    <!-- power -->
    <v-card class="legend-container">
      <div class="pa-3">
        <h4 class="caption font-weight-bold mb-2">Situation</h4>

        <v-layout row wrap>
          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #f66451" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Leaning strongly towards BRI</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #febf9a" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Cautious towards BRI</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #5251a4" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Against BRI</div>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LegendPower',
};
</script>

<style lang="stylus" scoped>
.legend-container {
  width: 12vw;

  .legend__circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    opacity: 0.85;
  }
}
</style>
